// Self-hosted QR code rendering for TOTP enrollment. Keeps the otpauth
// URI (which contains the secret) on our own servers instead of sending it
// to a third-party encoder.
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import QRCode from "qrcode";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const Input = z.object({ uri: z.string().startsWith("otpauth://").max(2048) });

export const renderTotpQr = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((i: unknown) => Input.parse(i))
  .handler(async ({ data }) => {
    const svg = await QRCode.toString(data.uri, {
      type: "svg",
      errorCorrectionLevel: "M",
      margin: 1,
      width: 200,
    });
    return { svg };
  });
